import React, { useState, useEffect } from "react";
import { TextField, Chip, Box } from "@mui/material";
import { useAppSelector, useAppDispatch } from "../../../../../app/hooks";
import { setTicketTypeConfig, addThirdPartyEmail, removeThirdPartyEmail } from "../../../../../services/ticketEasyService/model/ticketEasy/ticketTypeConfig/TicketTypeConfigSlice";

interface CpsiEmailInputProps {
  visible: boolean;
}

export const CpsiEmailInput: React.FC<CpsiEmailInputProps> = ({ visible }) => {
  const dispatch = useAppDispatch();
  const ticketTypeConfig = useAppSelector((state) => state.ticketTypeConfig.ticketTypeConfig);
  const [emailInput, setEmailInput] = useState("");
  
  // Extract initial emails from thirdPartyEmails
  useEffect(() => {
    // Reset email input when visibility changes
    if (!visible) {
      setEmailInput("");
    }
  }, [visible]);
  
  // Email validation function
  const isValidEmail = (email: string) => {
    // Simple regex for email validation
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Add email on Enter or comma
  const handleEmailInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === "Enter" || e.key === ",") && emailInput.trim()) {
      e.preventDefault();
      const emails = emailInput
        .split(/,|;/)
        .map((em) => em.trim())
        .filter(Boolean)
        .filter((em) => !ticketTypeConfig.thirdPartyEmails.includes(em)) // prevent duplicates
        .filter(isValidEmail); // only valid emails
      emails.forEach((email) => {
        dispatch(addThirdPartyEmail(email));
      });
      setEmailInput("");
    }
  };

  // Remove email chip
  const handleDeleteEmail = (emailToDelete: string) => {
    dispatch(removeThirdPartyEmail(emailToDelete));
  };

  if (!visible) return null;

  return (
    <Box mt={2}>
      <TextField
        label="CPSI Support Emails"
        placeholder="Enter email and press Enter or comma"
        value={emailInput}
        onChange={(e) => setEmailInput(e.target.value)}
        onKeyDown={handleEmailInputKeyDown}
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: ticketTypeConfig.thirdPartyEmails.map((email) => (
            <Chip
              key={email}
              label={email}
              onDelete={() => handleDeleteEmail(email)}
              sx={{ m: 0.5 }}
            />
          )),
        }}
        helperText="Multiple emails allowed. Press Enter or comma after each."
      />
    </Box>
  );
};
